export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar-minimizer/index.ts